export default "__VITE_ASSET__DXsj7JQs__"